
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavySleetShowersDay as ObiLightningHeavySleetShowersDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-sleet-showers-day.js';
 
 
 

 
 export const ObiLightningHeavySleetShowersDay = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-sleet-showers-day',
   elementClass: ObiLightningHeavySleetShowersDayElement,
   events: {
     
   }
  });
 
 